import { CampaignAlertsWebhook, WebhookAuthType } from '../../types';

export const getDefaultDestinationsFormValues = (webhook?: CampaignAlertsWebhook) => {
  return {
    name: webhook?.name ?? '',
    endpoint: webhook?.endpoint ?? '',
    authType: webhook?.authType ?? WebhookAuthType.NONE,
    authToken: webhook?.authToken ?? '',
    clientId: webhook?.clientId ?? '',
    clientSecret: webhook?.clientSecret ?? '',
    tokenEndpoint: webhook?.tokenEndpoint ?? '',
  };
};
